// extracted by mini-css-extract-plugin
export default {"item":"BurgerIngredientCard_item__Bu5x9","price":"BurgerIngredientCard_price__t4Gq6","title":"BurgerIngredientCard_title__spygw","link":"BurgerIngredientCard_link__KqV9L"};